<div class="dictionary-section section-pd">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="trinka-title text-center mb-0">
                    <h2>各専門分野の修正例</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="academic_slider_section mt-1">
            <div id="suggests_corrections" class="carousel slide" data-ride="carousel">
                <div class="row align-items-center justify-content-center">
                    <div class="col-lg-6 col-md-7">
                        <div class="position-relative gt-features gt-features1">
                            <ul class="carousel-indicators">
                                <li class="gt-wrapper c-card active" data-target="#suggests_corrections" data-slide-to="0">
                                    <span>医学</span>
                                </li>
                                <li class="gt-wrapper c-card" data-target="#suggests_corrections" data-slide-to="1">
                                    <span>生物学</span>
                                </li>
                                <li class="gt-wrapper c-card" data-target="#suggests_corrections" data-slide-to="2">
                                    <span>物理学</span>
                                </li>
                                <li class="gt-wrapper c-card" data-target="#suggests_corrections" data-slide-to="3">
                                    <span>社会科学</span>
                                </li>
                                <li class="gt-wrapper c-card"  data-target="#suggests_corrections" data-slide-to="4">
                                    <span>工学</span>
                                </li>
                                <li class="gt-wrapper c-card"  data-target="#suggests_corrections" data-slide-to="5">
                                    <span>化学</span>
                                </li>
                                <li class="gt-wrapper c-card"  data-target="#suggests_corrections" data-slide-to="6">
                                    <span>地質学</span>
                                </li>
                                <li class="gt-wrapper c-card"  data-target="#suggests_corrections" data-slide-to="7">
                                    <span>コンピュータサイエンス</span>
                                </li>
                                <li class="gt-wrapper c-card"  data-target="#suggests_corrections" data-slide-to="8">
                                    <span>経済学</span>
                                </li>
                            </ul>
                            
                            <div class="hr-line l33"></div>
                            <div class="hr-line l66"></div>
                            <div class="vr-line l33"></div>
                            <div class="vr-line l50 d-none"></div>
                            <div class="vr-line l66"></div>
                        </div>                
                        <!-- <div class="bullet_points_sections">
                            <span class="top_diviedLine"></span>
                            <ul class="carousel-indicators">
                                <li data-target="#suggests_corrections" data-slide-to="0" class="active">
                                    <i>Medicine</i>
                                </li>
    
                                <li data-target="#suggests_corrections" data-slide-to="1">
                                    <i>Biology</i>
                                </li>
    
                                <li data-target="#suggests_corrections" data-slide-to="2">
                                    <i>Physics</i>
                                </li>
    
                                <li data-target="#suggests_corrections" data-slide-to="3">
                                    <i>Social sciences</i>
                                </li>
    
                                <li data-target="#suggests_corrections" data-slide-to="4">
                                    <i>Engineering</i>
                                </li>
    
                                <li data-target="#suggests_corrections" data-slide-to="5">
                                    <i>Chemistry</i>
                                </li>
    
                                <li data-target="#suggests_corrections" data-slide-to="6">
                                    <i>Geology</i>
                                </li>
    
                                <li data-target="#suggests_corrections" data-slide-to="7">
                                    <i>Computer science</i>
                                </li>
    
                                <li data-target="#suggests_corrections" data-slide-to="8">
                                    <i>Economics</i>
                                </li>
                            </ul>
                            <span class="bottom_diviedLine"></span>
                        </div> -->
                    </div>

                    <div class="col-lg-6 col-md-7">
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <h4>医学</h4>  
                                <p>The physician recommended a throrough examination of the <span class="inline-block">gastrointestial</span> <span class="themeColor d-inline">gastrointestinal</span> tract.</p>
                            </div>
    
                            <div class="carousel-item">
                                <h4>生物学</h4>
                                <p>The most abundant <span class="d-inline">phylla</span> <span class="themeColor d-inline">phyla</span> were <span class="d-inline">Pseudomonodota</span> <span class="themeColor d-inline">Pseudomonadota</span> (22%) and <span class="d-inline">Bacterodota</span> <span class="themeColor d-inline">Bacteroidota</span> (18%).
                                </p>
                            </div>
    
                            <div class="carousel-item">
                                <h4>物理学</h4>
                                <p>Stength of IMF-sensitive stellar <span class="d-inline">absorbtion</span> <span class="themeColor d-inline">absorption</span> features is regulated by the ratio of dwarf to giant stars.</p>
                            </div>
    
                            <div class="carousel-item">
                                <h4>社会科学</h4>
                                <p>The elements of protest masculinity discount the <span class="">embodimint</span> <span class="themeColor d-inline">embodiment</span> of pure inclusive masculinity.
                                </p>
                            </div>
    
                            <div class="carousel-item">
                                <h4>工学</h4>
                                <p>We presented a novel approach to derive <span class="d-inline">nonliner</span> <span class="themeColor d-inline">nonlinear</span> filters from schematics of audio  <span class="d-inline">circits</span> <span class="themeColor d-inline">circuits</span>.
                                </p>
                            </div>
    
                            <div class="carousel-item">
                                <h4>化学</h4>
                                <p>Adjunct therapy with <span>hyaluranic</span> <span class="themeColor d-inline">hyaluronic</span> acid provides a long lasting therapeutic effect.
                                </p>
                            </div>
    
                            <div class="carousel-item">
                                <h4>地質学</h4>
                                <p>The low contents of incompatible elements indicate negligible involvement of <span class="">terrigeneous</span> <span class="themeColor">terrigenous</span> clastics during the deposition.</p>
                            </div>
    
                            <div class="carousel-item">
                                <h4>コンピュータサイエンス</h4>
                                <p>A new deep <span class="d-inline">regulization</span> <span class="themeColor d-inline">regularization</span> mechanism allows the learning model to unlearn biased information.</p>
                            </div>
    
                            <div class="carousel-item">
                                <h4>経済学</h4>
                                <p>Use of monetary <span class="">agregates</span> <span class="themeColor d-inline">aggregates</span> as indicators of policy is controversial because of many factors.
                                </p>
                            </div>
    
                            <a class="carousel-control-prev" href="#suggests_corrections" data-slide="prev" aria-label="Previous Slide">
                                <span class="">
                                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;" xml:space="preserve">
                                        <g>
                                            <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                                l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                                C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                            <g>
                                            </g>
                                            <g>
                                            </g>
                                            <g>
                                            </g>
                                            <g>
                                            </g>
                                            <g>
                                            </g>
                                            <g>
                                            </g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                    </svg>
                                </span>
                            </a>
                            <a class="carousel-control-next" href="#suggests_corrections" data-slide="next" aria-label="Next Slide">
                                <span class="">
                                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;" xml:space="preserve">
                                        <g>
                                            <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                                l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                                C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                            <g>
                                            </g>
                                            <g>
                                            </g>
                                            <g>
                                            </g>
                                            <g>
                                            </g>
                                            <g>
                                            </g>
                                            <g>
                                            </g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                    </svg>
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>